import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 首页路由在 public 文件夹里

export default new Router({
  mode: 'history',
  base:'/hh-wx/',
  routes: process.env.VUE_APP_MODULE
    ? [
        ...require("./views/public").default,
        ...require(`./views/${process.env.VUE_APP_MODULE}`).default
      ]
    : [
        // 环境变量没有指定，则编译全部业务模块
        ...require("./views/public").default,
        ...require("./views/cdy").default,
        ...require("./views/account").default,
        ...require("./views/positions").default,
        ...require("./views/recruit").default,
        ...require("./views/employer").default,
        ...require("./views/recommend").default,
        ...require("./views/aiMatch").default,
        ...require("./views/pa").default,
        ...require("./views/subscribe").default,
        ...require("./views/order").default,
        ...require("./views/search").default,
        ...require("./views/share").default,
        ...require("./views/resume").default,
        ...require("./views/activity").default,
        ...require("./views/yearReport").default,
        ...require("./views/acts").default,
        ...require("./views/report").default
      ]
});
